import { Content, Header, Body } from 'launch/components/AppContent';
import { Switch } from 'react-router-dom';
import AuthModal from 'launch/components/AuthModal';
import BriefHeader from 'launch/components/BriefHeader';
import BriefStatus from 'launch/components/BriefStatus';
import Portal from 'common/components/Portal';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Title from 'launch/components/Title';
import Viewport from 'common/utils/viewport';
import routes from 'launch/routes';
import { Source } from 'launch/consts/signupSource';

class App extends Component {
    static childContextTypes = {
        viewport: PropTypes.instanceOf(Viewport),
    };

    getChildContext() {
        return {
            viewport: this.viewport,
        };
    }

    componentWillMount() {
        this.viewport = new Viewport();
    }

    componentDidMount() {
        this.viewport.on('change', this.forceUpdate.bind(this));
    }

    componentWillUnmount() {
        this.viewport.removeAllListeners('change');
    }

    render() {
        return (
            <Content>
                <Title />

                <Portal portal="[data-status-container]">
                    <BriefStatus />
                </Portal>
                <Header>
                    <BriefHeader />
                </Header>
                <Body>
                    <Switch>{routes}</Switch>
                </Body>
                <AuthModal source={Source.CONTESTS_LAUNCH} />
            </Content>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./js/launch/components/App.jsx